import React from "react";
import { OrderApiData, ApiResponse } from "@swiggy-private/payment-types";

export interface ConfirmOrderContextValue {
    confirmOrderContext: ApiResponse<OrderApiData> | undefined;
    setConfirmOrderContext: (confirmOrderContext: ApiResponse<OrderApiData> | undefined) => void;
}

const INIT_STATE: ApiResponse<OrderApiData> = {
    data: null,
    statusCode: 0,
    statusMessage: "",
    rawResponse: undefined,
};

export const ConfirmOrderContext = React.createContext<ConfirmOrderContextValue>({
    confirmOrderContext: INIT_STATE,
    setConfirmOrderContext: () => void 0,
});

if (__DEV__) {
    ConfirmOrderContext.displayName = "Confirm Order";
}
